// import React, { useState } from "react";

// const IconButton = ({
//   children,
//   onClick,
//   isHoverColor = false, // Control whether hover color effect is enabled
//   bgColor = "#f9f9fb", // Default background color
//   textColor = "#7c7c7c", // Default text color
//   bordernone, // Optional border condition
//   newhover, // New hover functionality
//   infoText,
//   tooltipPosition = "bottom",
//   tooltipOffset = "0",
//   tooltipWidth = null, // Now accepts direct width value like "600px"
// }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   const [currentTextColor, setCurrentTextColor] = useState(textColor);
//   const [currentBgColor, setCurrentBgColor] = useState(bgColor);

//   const handleMouseEnter = () => {
//     setIsHovered(true);
//     if (isHoverColor) setIsHovered(true);
//     if (newhover) {
//       setCurrentTextColor("black");
//       setCurrentBgColor("#f6f6f6");
//     }
//   };

//   const handleMouseLeave = () => {
//     setIsHovered(false);
//     if (isHoverColor) setIsHovered(false);
//     if (newhover) {
//       setCurrentTextColor(textColor);
//       setCurrentBgColor(bgColor);
//     }
//   };

//   return (
//     <div className="relative flex items-center justify-center group">
//         {(infoText && isHovered )&& (
//         <div className="relative inline-flex group">
         

//           {/* Tooltip with direct width control */}
//           <div 
//             className={`
//               absolute z-50
//               invisible group-hover:visible
//                bg-[#4A1E73] text-[#FFFFFF] px-3 py-2 rounded 
//               whitespace-normal min-w-[10px]
//               ${getTooltipPositionClasses(tooltipPosition)}
//               ${tooltipOffset ? `m-${tooltipOffset}` : ''}
//             `}
//             style={{
//               width: tooltipWidth || undefined
//             }}
//           >
//             {infoText}
//           </div>
//         </div>
//       )}
//       {/* Button */}
//       <button
//         onClick={onClick}
//         style={{
//           backgroundColor: isHovered && isHoverColor ? "#6E2D90" : currentBgColor,
//           color: isHovered && isHoverColor ? "white" : currentTextColor,
//         }}
//         className={`p-2 w-[35px] h-[34px] py-[5px] px-[9px] cursor-pointer rounded-lg font-medium transition-all duration-300 flex justify-center items-center ease-in-out focus:outline-none
//                      ${bordernone ? bordernone : 'border-1 border-[#ddd]'}
//                      ${newhover ? 'hover:border-gray-400':''}`}
//         onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//       >
//         <span className="inline-block w-10 text-current">{children}</span>
//       </button>

//       {/* Tooltip */}
     
//     </div>
//   );
// };
// // Positioning helper remains the same
// const getTooltipPositionClasses = (position) => {
//   switch(position) {
//     case 'top': return 'bottom-full left-1/2 -translate-x-1/2 mb-6';
//     case 'bottom': return 'top-full left-1/2 -translate-x-1/2 mt-6';
//     case 'left': return 'right-full top-1/2 -translate-y-1/2 mr-6';
//     case 'right': return 'left-full top-1/2 -translate-y-1/2 ml-11';
//     default: return 'bottom-full left-1/2 -translate-x-1/2 mb-6';
//   }
// };
// export default IconButton;

import React, { useState } from "react";

const IconButton = ({
  size="normal",
  children,
  onClick,
  isHoverColor = false, // Control whether hover color effect is enabled
  bgColor = "#f9f9fb", // Default background color
  textColor = "#7c7c7c", // Default text color
  bordernone, // Optional border condition
  newhover, // New hover functionality
  infoText,
  tooltipPosition = "bottom",
  tooltipOffset = "0",
  tooltipWidth = null, // Now accepts direct width value like "600px"
  type = "default", // New type prop: "default" or "primary"
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [currentTextColor, setCurrentTextColor] = useState(textColor);
  const [currentBgColor, setCurrentBgColor] = useState(bgColor);
  const getSizeClasses = () => {
    if (size === "large") {
      return "w-[50px] h-[50px] p-4";
    }
    return "w-[35px] h-[34px] p-2  py-[5px] px-[9px]";
  };
  const handleMouseEnter = () => {
    setIsHovered(true);
    if (isHoverColor) setIsHovered(true);
    if (newhover && type !== "primary") { // Don't apply newhover colors for primary type
      setCurrentTextColor("black");
      setCurrentBgColor("#f6f6f6");
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (isHoverColor) setIsHovered(false);
    if (newhover && type !== "primary") { // Don't apply newhover colors for primary type
      setCurrentTextColor(textColor);
      setCurrentBgColor(bgColor);
    }
  };

  // Determine styles based on type
  const getButtonStyles = () => {
    if (type === "primary") {
      return {
        backgroundColor: isHovered && isHoverColor ? "#5a1d8c" : undefined, // Darker purple on hover
        color: "white",
        backgroundImage: isHovered && isHoverColor ? "linear-gradient(to right, #5a1d8c, #7e3ab9)" : "linear-gradient(to right, #6366f1, #8b5cf6)",
      };
    }
    
    return {
      backgroundColor: isHovered && isHoverColor ? "#6E2D90" : currentBgColor,
      color: isHovered && isHoverColor ? "white" : currentTextColor,
    };
  };

  const getButtonClasses = () => {
    const baseClasses = `  ${getSizeClasses()}  cursor-pointer rounded-lg font-medium transition-all duration-300 flex justify-center items-center ease-in-out focus:outline-none
                     ${bordernone ? bordernone : 'border-1 border-[#ddd]'}
                     ${newhover && type !== "primary" ? 'hover:border-gray-400' : ''}`;
    
    if (type === "primary") {
      return `${baseClasses} bg-gradient-to-r from-indigo-500 to-purple-500`;
    }
    
    return baseClasses;
  };

  return (
    <div className="relative flex items-center justify-center group">
        {(infoText && isHovered )&& (
        <div className="relative inline-flex group">
         

          {/* Tooltip with direct width control */}
          <div 
            className={`
              absolute z-50
              invisible group-hover:visible
               bg-[#4A1E73] text-[#FFFFFF] px-3 py-2 rounded 
              whitespace-normal min-w-[10px]
              ${getTooltipPositionClasses(tooltipPosition)}
              ${tooltipOffset ? `m-${tooltipOffset}` : ''}
            `}
            style={{
              width: tooltipWidth || undefined
            }}
          >
            {infoText}
          </div>
        </div>
      )}
      {/* Button */}
      <button
        onClick={onClick}
        style={getButtonStyles()}
        className={getButtonClasses()}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <span className="inline-block w-10 text-current">{children}</span>
      </button>

      {/* Tooltip */}
     
    </div>
  );
};

// Positioning helper remains the same
const getTooltipPositionClasses = (position) => {
  switch(position) {
    case 'top': return 'bottom-full left-1/2 -translate-x-1/2 mb-6';
    case 'bottom': return 'top-full left-1/2 -translate-x-1/2 mt-6';
    case 'left': return 'right-full top-1/2 -translate-y-1/2 mr-6';
    case 'right': return 'left-full top-1/2 -translate-y-1/2 ml-11';
    default: return 'bottom-full left-1/2 -translate-x-1/2 mb-6';
  }
};

export default IconButton;